import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "position-relative" }
const _hoisted_2 = { class: "image-overlay position-absolute pa-4" }
const _hoisted_3 = { class: "d-flex flex-column flex-sm-row align-sm-center justify-space-between" }
const _hoisted_4 = { class: "flex-grow-1 pr-md-4" }
const _hoisted_5 = { class: "text-h5 font-weight-bold text-white mb-1" }
const _hoisted_6 = { class: "text-white text-opacity-90 mb-4 mb-sm-0" }
const _hoisted_7 = { class: "text-right mt-auto" }

import { computed, type PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import { useDisplay } from 'vuetify'
import { getImageKitUrls } from '@/app/system/helper'
import { PRODUCT_DESC_MAX_LEN } from '@/app/constants'
import store from '@/app/store'
import RoomImages from '@/components/Rooms/RoomImages.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'PackagesListItem',
  props: {
  item: {
    type: Object as PropType<{
      id: string
      name: string
      guaranteeType: string
      hasServices: boolean
      showAmongResults: boolean
      maxAdultOccupancy: number
      maxChildOccupancy: number
      maxOccupancy: number
      minOccupancy: number
      descriptions: {
        images: Array<{
          createDateTime: string
          imageId: string
          imagePath: string
          lastModifyDateTime: string
          sort: number
        }>
        texts: Array<string>
      }
    }>,
    required: true
  }
},
  setup(__props) {

const props = __props

const { t } = useI18n()
const { smAndDown } = useDisplay()

const selectedImages = computed(() =>
  getImageKitUrls(props.item.descriptions?.images, 'Mobile', true)
)

const description = computed(() => {
  const text = props.item.descriptions?.texts?.[0] || ''
  const maxLen = smAndDown.value
    ? Math.floor(PRODUCT_DESC_MAX_LEN / 2)
    : PRODUCT_DESC_MAX_LEN
  return text.length < maxLen ? text : text.slice(0, maxLen) + '...'
})

const btnText = computed(() => {
  return store.getters.loading
    ? t('Search#Results#Room#Button Please wait')
    : t('AvailabilityItem#Button Details & Book')
})

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "mb-6",
    elevation: "1",
    rounded: "lg"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.item.id)
          ? (_openBlock(), _createBlock(RoomImages, {
              key: 0,
              images: selectedImages.value,
              lazy: false,
              "link-to": { name: 'package', params: { packageId: __props.item.id } },
              height: "200",
              class: "package-image"
            }, null, 8, ["images", "link-to"]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_chip, {
          class: "position-absolute top-0 left-0 rounded-0 text-uppercase text-white",
          size: "small",
          color: "#E6AF0E",
          variant: "flat"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('Packages#Item#Badge Special deal')), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(__props.item.name), 1),
              _createElementVNode("p", _hoisted_6, _toDisplayString(description.value), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: { name: 'package', params: { packageId: __props.item.id } },
                style: {"text-decoration":"none"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "flat",
                    class: "px-4 text-none",
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(btnText.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})